import { SnackbarConfig } from 'libono';

export const GuardOAuthSnackbars = {
  failOAuth: {
    message: `Debes iniciar sesión`,
    closeBtn: SnackbarConfig.strings.close,
    config: {
      panelClass: SnackbarConfig.classes.danger,
      duration: SnackbarConfig.durations.danger,
    },
  },
  failNotOAuth: {
    message: `Ya iniciaste sesión`,
    closeBtn: SnackbarConfig.strings.close,
    config: {
      panelClass: SnackbarConfig.classes.danger,
      duration: SnackbarConfig.durations.danger,
    },
  },
};
